import { Alert, Box, Divider, IconButton, Tooltip, useMediaQuery } from "@mui/material";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

import Decline from "./Decline";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import jwtDecode from "jwt-decode";
import { useImperativeHandle } from "react";
import { forwardRef } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import { grey } from "@mui/material/colors";
import { toast } from "react-toastify";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { useFilterStore } from "./filterStore";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import { useTheme } from "@mui/material/styles";

const SDRDiscount = forwardRef((props, ref) => {
  const theme = useTheme();
   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [successMsg, setSuccessMsg] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [stateData, setStateData] = useState({
    filter: "",
    columnState: "",
    columnGroupState: "",
  });
  const stateRef = useRef();
  const saveGridStateName = "sdr-discount-list";
  // const [editableRow, setEditableRow] = useState();
  const discountUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;
  const navigate = useNavigate();
  const gridStyle = useMemo(
    () => ({ height: "calc(100% - 25px)", width: "100%" }),
    [],
  );
  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));

  const DeclineComponent = (params) => {
    const [open, setOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);

    const handleDialogOpen = async () => {
      try {
        const id = params.data.id;

        await OAuthService.addData(discountUrl + "api/approveSpecialDiscount", {
          specialDiscountId: id,
          specialDiscType: "SDR",
          status: "DECLINED",
        });
        setOpen(true);
        const rowNode = params.api.getRowNode(id);

        if (rowNode) {
          rowNode.setDataValue("status", "DECLINED");

          params.api.refreshCells({
            rowNodes: [rowNode],
            columns: ["status"],
            force: true,
          });
        }
      } catch (err) {
        toast.error(err?.response?.data?.errorMessage || err.message);
      }
    };
    const handleClose = () => {
      setOpen(false);
    };
    const handleDeleteSpecialDiscount = async () => {
      const id = params?.data?.id;

      try {
        await OAuthService.deleteData(discountUrl + `api/specialDiscounts`, id);

        toast.success("Discount Deleted successfully!");
        setDeleteOpen(false);

        const rowNode = params.api.getRowNode(id);
        if (rowNode) {
          params.api.applyTransaction({ remove: [rowNode.data] });
        }
      } catch (error) {
        toast.error(error?.response?.data?.errorMessage || error.message);
      }
    };

    return (
      <div className="flex item-center justify-center gap-6">
        <Tooltip title={"Decline"}>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              handleDialogOpen();
            }}
            disabled={params?.data?.status !== "WAITING"}
          >
            <FuseSvgIcon
              size={14}
              className={
                params?.data?.status === "WAITING"
                  ? "text-red-600"
                  : "text-stone-500"
              }
            >
              heroicons-outline:x
            </FuseSvgIcon>
          </IconButton>
        </Tooltip>
        <Tooltip title={"Delete"}>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              setDeleteOpen(true);
            }}
            disabled={
              params?.data?.status !== "WAITING" &&
              params?.data?.status !== "PENDING"
            }
          >
            <FuseSvgIcon
              size={14}
              className={
                params?.data?.status === "WAITING" ||
                params?.data?.status === "PENDING"
                  ? "text-red-600"
                  : "text-stone-500"
              }
            >
              heroicons-outline:trash
            </FuseSvgIcon>
          </IconButton>
        </Tooltip>
        <Decline
          open={open}
          onClose={handleClose}
          content={`Order ${params?.data?.project} special discount decline`}
        />
        <Dialog open={deleteOpen} onClose={() => setDeleteOpen(false)} onClick={(e) => e.stopPropagation()}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent id="alert-dialog-description">
            <DialogContentText>
              {`Are you sure want to delete Order ${params?.data?.project}  special discount?`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDeleteOpen(false)} autoFocus>
              No
            </Button>
            <Button onClick={handleDeleteSpecialDiscount}>Yes</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  };
  var filterParams = {
    comparator: (filterLocalDateAtMidnight, cellValue) => {
      var dateAsString = cellValue;
      //Convert function date format from "2024-02-23T17:16:43.974" to 23/02/2024
      const date = new Date(dateAsString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const formattedDate = `${day}/${month}/${year}`;
      if (formattedDate == null) return -1;
      var dateParts = formattedDate.split("/");
      var cellDate = new Date(
        Number(dateParts[2]),
        Number(dateParts[1]) - 1,
        Number(dateParts[0]),
      );
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
      }
      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      }
      if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      }
      return 0;
    },
    maxValidYear: new Date().getFullYear(),
  };
  const showStatusIcon = (props) => {
    let statusIcon = "";
    if (props?.data?.sdrStatus === "PENDING") {
      statusIcon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: "#fe9705", marginRight: 4 }}>
            material-solid:access_time_filled
          </FuseSvgIcon>
          {props?.value}
        </>
      );
    }
    if (props?.data?.sdrStatus === "WAITING") {
      statusIcon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: "#fcd260", marginRight: 4 }}>
            material-solid:timelapse
          </FuseSvgIcon>
          {props?.value}
        </>
      );
    }
    if (props?.data?.sdrStatus === "APPROVED") {
      statusIcon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: "#3ac430", marginRight: 4 }}>
            material-solid:check_circle
          </FuseSvgIcon>
          {props?.value}
        </>
      );
    }
    if (props?.data?.sdrStatus === "REJECTED") {
      statusIcon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: "#d11313", marginRight: 4 }}>
            material-solid:do_not_disturb
          </FuseSvgIcon>
          {props?.value}
        </>
      );
    }
    if (props?.data?.sdrStatus === "DECLINED") {
      statusIcon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: "#d11313", marginRight: 4 }}>
            material-solid:cancel
          </FuseSvgIcon>
          {props?.value}
        </>
      );
    }
    return (
      <p className="flex items-center">
        {props?.column?.colId === "customerNum" && props?.value
          ? statusIcon
          : props?.value}
      </p>
    );
  };

  const STATUS_COLORS = {
    WAITING: { bg: "#fcd260", text: "#5c4400" },
    PENDING: { bg: "#fe9705", text: "#ffffff" },
    APPROVED: { bg: "#3ac430", text: "#ffffff" },
    REJECTED: { bg: "#d11313", text: "#ffffff" },
    DECLINED: { bg: "#8c1010", text: "#ffffff" },
  };

  const showStatusBadge = (params) => {
    const value = params?.value;
    const colors = STATUS_COLORS[value] || { bg: "#9e9e9e", text: "#ffffff" };

    if (!value) return null;

    return (
      <span
        style={{
          display: "inline-block",
          padding: "2px 10px",
          borderRadius: 999,
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: 0.3,
          backgroundColor: colors.bg,
          color: colors.text,
          whiteSpace: "nowrap",
        }}
      >
        {value}
      </span>
    );
  };
  const handleDateFormat = (props) => {
    return props.value && moment(props.value).format("DD-MM-YYYY");
  };

  const [columnDefsSDR, setColumnDefsSDR] = useState([
    {
      field: "customerId",
      headerName: "Customer No",
      cellRenderer: (params) => showStatusIcon(params),
      enableRowGroup: true,
      minWidth: 80,
      cellStyle: {
        justifyContent: "center",
        textAlign: "center", // Center the cell data horizontally
      },
    },
    {
      field: "customerName",
      headerName: "Customer",
      minWidth: 250,
      enableRowGroup: true,
    },
    {
      field: "territory",
      headerName: "Territory",
      minWidth: 50,
      enableRowGroup: true,
      cellStyle: {
        justifyContent: "center",
        textAlign: "center",
      },
    },

    {
      field: "vendorName",
      headerName: "Product",
      enableRowGroup: true,

      minWidth: 150,
    },
    {
      field: "orderCategory",
      enableRowGroup: true,
      headerName: "Order Category",
      minWidth: 60,
      cellStyle: {
        justifyContent: "center",
        textAlign: "center",
      },
    },
    {
      field: "project",
      enableRowGroup: true,
      headerName: "Order Reference",
      cellStyle: {
        justifyContent: "center",
        textAlign: "center",
      },
      minWidth: 60,
    },
    {
      field: "projectName",
      enableRowGroup: true,
      headerName: "Project Name",
      minWidth: 100,
    },
    {
      field: "phase",
      enableRowGroup: true,
      headerName: "Project Phase",
      cellStyle: {
        justifyContent: "center",
        textAlign: "center",
      },
      minWidth: 70,
    },
    {
      field: "status",
      headerName: "SDR Status",
      minWidth: 110,
      cellRenderer: showStatusBadge,
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },

    {
      field: "createdByUser",
      enableRowGroup: true,
      headerName: "Requested By",
      minWidth: 120,
    },
    {
      field: "requestedDate",
      enableRowGroup: true,
      headerName: "Requested Date",
      cellRenderer: handleDateFormat,
      filter: "agDateColumnFilter",
      filterParams,
      cellStyle: {
        justifyContent: "center",
        textAlign: "center",
      },
      minWidth: 120,
    },
    {
      field: "approvedBy",
      enableRowGroup: true,
      headerName: "Approved By/Rejected By",
      minWidth: 120,
    },
    {
      field: "approvedDate",
      enableRowGroup: true,
      cellRenderer: handleDateFormat,
      minWidth: 120,
      headerName: "Approved Date/Rejected Date",
      filter: "agDateColumnFilter",
      filterParams,
      cellStyle: {
        justifyContent: "center",
        textAlign: "center",
      },
    },

    {
      colId: "actions",
      minWidth: 90,
      maxWidth: 90,
      editable: false,
      floatingFilter: false,
      filter: false,
      sortable: false,
      resizable: false,
      pinned: "right",
      cellRenderer: DeclineComponent,
    },
  ]);

  const onGridReady = useCallback((params) => {
    // gridRef.current = params;
    setGridApi(params?.api);
  }, []);

  useEffect(() => {
    props.successMsg(successMsg);
  }, [successMsg]);

  const handleSDRApprove = async () => {
    try {
      let id = selectedRows?.map((data) => data.id);
      let model = {
        orderId: id,
        specialDiscType: "sdr",
        status: "APPROVED",
      };

      await OAuthService.addData(
        discountUrl + "api/approveSpecialDiscount",
        model,
      );
      setSuccessMsg("SDR discount approved successfully.");
      loadSDRDiscount();
      return "SDR discount approved successfully.";
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
    }
  };

  useEffect(() => {
    if (props.tabValue === 0) {
      if (gridApi) {
        loadSDRDiscount(props.filterPagination);
      }
    }
  }, [props.filterPagination, gridApi]);

  const cleanSearchQuery = (query) => {
    for (let key in query) {
      if (
        query[key] === "" ||
        query[key] === null ||
        query[key] === undefined
      ) {
        delete query[key];
      }
    }
    return query;
  };
  const loadSDRDiscount = async (query) => {
    gridApi?.showLoadingOverlay();
    try {
      const searchQuery = { ...query };
      if (searchQuery.specialDiscStatus === "All") {
        delete searchQuery.specialDiscStatus;
      }
      if (searchQuery.specialDiscStatus === "PENDING") {
        searchQuery.sortBy = "requestedDate";
      } else if (searchQuery.specialDiscStatus === "APPROVED") {
        searchQuery.sortBy = "approvedDate";
      } else {
        searchQuery.sortBy = "createdDate";
      }

      const updatedSearchQuery = cleanSearchQuery(searchQuery);
      // useFilterStore.getState().setFilters(FilterData)
      const url = await OAuthService.addData(
        discountUrl + "api/searchSpecialDiscount",
        updatedSearchQuery,
      );
      const userUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;
      const userlist = await OAuthService.getList(
        userUrl + `?sort=firstName,asc&size=1000`,
      );
      const users = [];
      userlist.data?._embedded?.users.map((data, key) => {
        data.name = data.firstName + " " + data.lastName;
        users[data.email] = data.name;
        return data;
      });
      if (url?.data?.content) {
        let discounts = url?.data?.content.map((discount) => {
          discount.createdByUser = users[discount.createdByUser]
            ? users[discount.createdByUser]
            : discount.createdByUser;
          discount.approvedBy = users[discount.approvedBy]
            ? users[discount.approvedBy]
            : discount.approvedBy;

          return discount;
        });
        setRowData(discounts);
        props?.setDiscountCount(url?.data?.totalPages);
        props.SDRCount();
        if (token?.scope?.includes("ROLE_MD")) {
          gridRef?.current?.columnApi?.applyColumnState({
            state: [{ colId: "decline", hide: true }],
          });
        } else {
          gridRef?.current?.columnApi?.applyColumnState({
            state: [{ colId: "decline", hide: false }],
          });
        }
        gridRef?.current?.api?.refreshCells();
      } else {
        setRowData([]);
      }
      //
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
    } finally {
      gridApi?.hideOverlay();
    }
  };

  const onSelectionChanged = (params) => {
    setSelectedRows(params?.api?.getSelectedRows());
  };
 
 const goToRoleEdit = useCallback(
      (data) => {
        if (data?.id !== undefined) {
          navigate("/special-discount-details-sdr/" + data.id);
        }
      },
      [navigate],
    );
    const onRowDoubleClicked = (params) => {
      if (isMobile) return;
      goToRoleEdit(params?.data);
    };

   const onRowClicked = (params) => {
  if (!isMobile) return;

  const target = params?.event?.target;
  if (target?.closest?.("button, a, input, .MuiIconButton-root, [role='button']")) {
    return;
  }

  if (params?.column?.getColId?.() === "actions") return;

  goToRoleEdit(params?.data);
};
  const defaultColDef = useMemo(() => {
    return {
      sortable: true,
      filter: "agMultiColumnFilter",
      floatingFilter: true,
      resizable: true,
      flex: 1,
      enableRowGroup: true,
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
    };
  }, []);

  useEffect(() => {
    if (saveGridStateName) {
      stateRef.current = {
        screenName: saveGridStateName,
        screenState: stateData,
      };
    }
  }, [stateData]);
  const onFirstDataRendered = (params) => {
    const savedState = localStorage.getItem(`gridState-${saveGridStateName}`);
    if (savedState) {
      try {
        const data = JSON.parse(savedState);
        if (data.screenState?.filter) {
          params.api.setFilterModel(data.screenState.filter);
        }
        if (data.screenState?.columnState) {
          params.columnApi.applyColumnState({
            state: data.screenState.columnState,
            applyOrder: true,
          });
        }
        if (data.screenState?.columnGroupState) {
          params.columnApi.setColumnGroupState(
            data.screenState.columnGroupState,
          );
        }
      } catch (err) {
        console.error("Failed to load grid state:", err);
      }
    }
  };
  useEffect(() => {
    const unloadCallback = () => {
      if (saveGridStateName && stateRef.current) {
        localStorage.setItem(
          `gridState-${saveGridStateName}`,
          JSON.stringify(stateRef.current),
        );
      }
    };

    window.addEventListener("beforeunload", unloadCallback);
    return () => {
      window.removeEventListener("beforeunload", unloadCallback);
      unloadCallback();
    };
  }, []);
  const onFilterChanged = (params) => {
    stateData.filter = params.api.getFilterModel();
    setStateData({ ...stateData });
  };

  const onColumnStateChanged = (params) => {
    stateData.columnState = params.columnApi.getColumnState();
    stateData.columnGroupState = params.columnApi.getColumnGroupState();
    setStateData({ ...stateData });
  };

  const onColumnGroupChange = (params) => {
    onColumnStateChanged(params);
  };

  const gridThemeClass =
    theme.palette.mode === "dark"
      ? "ag-theme-alpine-dark grid"
      : "ag-theme-alpine grid";

  return (
    <>
      <div style={gridStyle} className={gridThemeClass}>
        {props.showAlert && (
          <Alert severity="error">Please select order first!</Alert>
        )}
        <AgGridReact
          columnDefs={columnDefsSDR}
          onGridReady={onGridReady}
          // default
          ref={gridRef}
          rowData={rowData}
          wrapHeaderText={true}
          defaultColDef={defaultColDef}
          getRowId={(params) => params.data.id}
          autoHeaderHeight={true}
          domLayout={"autoHeight"}
          suppressRowTransform={true}
          rowSelection="multiple"
          editable={false}
          pagination={false}
          floatingFilter={true}
          onRowDoubleClicked={onRowDoubleClicked}
          hideCheckbox={true}
          animateRows={true}
          headerHeight={28}
          rowHeight={22}
          cacheBlockSize={20}
          cacheOverflowSize={2}
          maxBlocksInCache={2}
          rowGroupPanelShow={"always"}
          onFirstDataRendered={onFirstDataRendered}
          onFilterChanged={onFilterChanged}
          onRowClicked={onRowClicked}
          onColumnMoved={onColumnStateChanged}
          onColumnPinned={onColumnStateChanged}
          onColumnVisible={onColumnStateChanged}
          onColumnResized={onColumnStateChanged}
          onColumnRowGroupChanged={onColumnGroupChange}
          suppressDragLeaveHidesColumns={true}
          cellSelection={true}
          suppressRowClickSelection={true}
          onSelectionChanged={onSelectionChanged}
        />
      </div>
    </>
  );
});
export default SDRDiscount;
